import React from 'react';

import { useKlaviyoFormsQuery } from 'graphql/generated/graphql';

import { useAuth } from 'hooks/useAuth';
import useGraphaelDefaults from 'hooks/useGraphaelDefaults';

export const useFormsQuery = () => {
  const { data, refetch } = useKlaviyoFormsQuery(useGraphaelDefaults());

  const { isAuthenticated } = useAuth();

  React.useEffect(() => {
    refetch();
  }, [isAuthenticated, refetch]);

  return { data };
};
